/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import Menu from '../../../../components/Peyks/Menu'
import peykIcon from '../../../../assets/svg/PPeykMessage.svg'

import Table from '../../../../components/Peyks/peykMessage'

import { useNavigate } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { get } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

export default function index() {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate()
  
  const [peyks, setPeyks] = useState()
  const [peyksCount, setPeyksCount] = useState()
  const [totalPage, setTotalPage] = useState()
  
  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/peyk/messages/send')
  }

  const handlePageClick = (event) => {
    get(`/api/admin/peyks?page=${event.selected + 1}&token=${token}`)
      .then(respose => {
        setPeyks(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setPeyksCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }

  useEffect(() => {
    get(`/api/admin/message-peyks?token=${token}`)
      .then(respose => {
        console.log(respose)
        setPeyks(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setPeyksCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token, totalPage])

  document.title = 'پیام‌ها'

  return (
    <main id='panel'>
      <Menu page={'messages'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={peykIcon} width={30} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست پیام‌ها
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler}>ایجاد پیغام جدید</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد پیام‌ها
              </div>
              <div className="left">
                {peyksCount}
              </div>
            </div>

            <Table data={peyks} />
            <ReactPaginate
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>
          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
